import { Button, Container, FormField, Modal, SpaceBetween } from '@cloudscape-design/components';
import Calendar from "@cloudscape-design/components/calendar";
import { format, parse } from 'date-fns';
import React, { useEffect, useState } from 'react';
interface DatePickerModalProps {
    visible: boolean;
    close?: boolean;
    clear?: boolean;
    today?: boolean;
    tomorrow?: boolean;
    yesterday?: boolean;
    start?: Date;
    end?: Date;
    date?: string
    title?: string;
    subTitle?: string;
    onDismiss: () => void;
    onConfirm: (selectedDate: string) => void;
}
const DatePickerModal: React.FC<DatePickerModalProps> = ({
    visible,
    close = false,
    clear = true,
    today = false,
    tomorrow = false,
    yesterday = false,
    start = undefined,
    end = undefined,
    date = "",
    title = 'Seleccione',
    subTitle = '',
    onDismiss,
    onConfirm,
}) => {
    const [selectedDate, setSelectedDate] = useState<string>('');
    const handleDateChange = ({ detail }: { detail: { value: string } }) => {
        setSelectedDate(detail.value);
        onConfirm(format(parse(detail.value, "yyyy-MM-dd", new Date()), "dd-MM-yyyy"));
        onDismiss();
    };
    const dateClear = () => {
        setSelectedDate('')
        onConfirm('');
    }
    const dateToday = () => {
        let today = new Date();
        const normalizedStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const formatted = normalizedStart.toISOString().slice(0, 10);
        setSelectedDate(formatted)
        onConfirm(formatted);
    }
    const dateYesterday = () => {
        let today = new Date();
        today.setDate(today.getDate() - 1);
        const normalizedStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const formatted = normalizedStart.toISOString().slice(0, 10);
        setSelectedDate(formatted)
        onConfirm(formatted);
    }
    const dateTomorrow = () => {
        let today = new Date();
        today.setDate(today.getDate() + 1);
        const normalizedStart = new Date(today.getFullYear(), today.getMonth(), today.getDate())
        const formatted = normalizedStart.toISOString().slice(0, 10);
        setSelectedDate(formatted)
        onConfirm(formatted);
    }
    const normalizedStart = start ? new Date(start.getFullYear(), start.getMonth(), start.getDate()) : undefined;
    const normalizedEnd = end ? new Date(end.getFullYear(), end.getMonth(), end.getDate()) : undefined;
    //const normalizedDate = end ? new Date(date.getFullYear(), date.getMonth(), date.getDate()) : undefined;
    const isDateInRange = (date: Date) => {
        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if (normalizedStart && normalizedEnd) return d >= normalizedStart && d <= normalizedEnd;
        if (normalizedStart) return d >= normalizedStart;
        if (normalizedEnd) return d <= normalizedEnd;
        return true;
    };

    useEffect(() => {
    }, [visible]);

    return (
        <Modal
            visible={visible}
            onDismiss={onDismiss}
            size="small"
            header={title}
            footer={
                <SpaceBetween direction='horizontal' size='xs'>
                    {close && (
                        <Button variant="link" onClick={onDismiss}>Cerrar</Button>
                    )}
                    {yesterday && (
                        <Button variant="primary" onClick={dateYesterday}>Ayer</Button>
                    )}
                    {today && (
                        <Button variant="primary" onClick={dateToday}>Hoy</Button>
                    )}
                    {tomorrow && (
                        <Button variant="primary" onClick={dateTomorrow}>Mañana</Button>
                    )}
                    {clear && (
                        <Button variant="primary" onClick={dateClear}>Limpiar</Button>
                    )}
                </SpaceBetween>
            }
        >
            <FormField label={subTitle} stretch>
                <Container>
                    <Calendar
                        value={date}
                        onChange={handleDateChange}
                        locale="es-CL"
                        startOfWeek={1}
                        isDateEnabled={isDateInRange}
                    />
                </Container>
            </FormField>
        </Modal >
    );
};

export default DatePickerModal;